export const params = {
  includeDeleted: false,
  pageNumber: 1,
  pageSize: 15,
  orderBy: "createdAt",
  orderDirection: "desc",
};